import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from '../../core/http.service';
import { environment } from '../../../environments/environment';
import { HomeUrl } from '../../modules/home/services/home.url.service';

@Injectable({
  providedIn: 'root'
})
export class ShareButtonsService {

  constructor(
    private httpService: HttpService,
    private homeUrl: HomeUrl
  ) { }


  getShareButtons(): Observable<any> {
    const url = this.homeUrl.getShareButtons();
    return this.httpService.get<any>(url);
  }
  /**
   * Inject custom data into share buttons HTML
   * @param apiHtml - Original HTML from API
   * @param title - Title to share
   * @param url - URL to share
   * @returns Modified HTML with injected data
   */
  injectDataIntoShareButtons(apiHtml: string, title: string, url: string): string {
    if (!apiHtml) return '';

    const encodedTitle = encodeURIComponent(title);
    const encodedUrl = encodeURIComponent(url);

    // Replace placeholder values with actual data
    let modifiedHtml = apiHtml
      .replace(/linkurl=&amp;linkname=/g, `linkurl=${encodedUrl}&amp;linkname=${encodedTitle}`)
              .replace(/linkurl=&linkname=/g, `linkurl=${encodedUrl}&linkname=${encodedTitle}`);

      // Remove Instagram buttons from API response since Instagram doesn't support URL-based sharing
      // This prevents the "Page not available" error
      modifiedHtml = this.removeInstagramButtons(modifiedHtml);

      return modifiedHtml;
    }

    /**
     * Remove Instagram share buttons from HTML to prevent "Page not available" errors
     * Instagram deprecated URL-based sharing, so we use custom implementation instead
     */
    private removeInstagramButtons(html: string): string {
      if (!html) return '';

      // Remove Instagram buttons using various patterns
      let cleanedHtml = html
        // Remove Instagram links with various patterns
        .replace(/<a[^>]*instagram[^>]*>.*?<\/a>/gi, '')
        .replace(/<a[^>]*ig-[^>]*>.*?<\/a>/gi, '')
        // Remove Instagram share URLs
        .replace(/https?:\/\/(?:www\.)?instagram\.com\/share[^"'\s]*/gi, '')
        // Remove Instagram-related elements
        .replace(/<[^>]*class="[^"]*instagram[^"]*"[^>]*>.*?<\/[^>]*>/gi, '')
        // Clean up any empty or orphaned elements
        .replace(/<a[^>]*href=""[^>]*><\/a>/gi, '')
        .replace(/\s+/g, ' ')
        .trim();

      return cleanedHtml;
    }
 }
